import type { TaskImplementations, TaskMap } from "../types/TaskMap"
import { IsWorker } from "@pdfking/compatibility"
import { WorkerReceiver } from "@pdfking/functionpool"
import { ReceiverMaker } from "../internal/ReceiverMaker"

export const CreateWorkerReceiver = <TM extends TaskMap>(
  tasks: TaskImplementations<TM>
): void => {
  if (IsWorker()) WorkerReceiver(ReceiverMaker(tasks))
}
